"use client"
import React from 'react'
import Button from '../ui/Button'
import Image from 'next/image'
import { useRouter } from 'next/navigation'

const About = () => {
  const router = useRouter()
  return (
    <section className="md:py-15 py-10.5 md:px-5 px-4">
      <div className="max-w-346.25 mx-auto w-full relative">
        <div className="flex items-center flex-col lg:flex-row gap-8">
          <div className="lg:order-1 order-2 max-w-124.25 w-full flex items-center gap-0.75 h-full">
            <div className="bg-[#C7F8FF] rounded-lg px-2 sm:pl-8 sm:pr-7.5 pt-11 pb-11 relative m-auto h-full">
              <p className="text-[#1D1D1D] leading-6.5 tracking-[0.2px] md:text-left text-center">
                <span className="font-bold">
                  Vous lancez votre entreprise ?
                </span>
                <br />
                <br />
                Personne ne réussit sans se lancer. Spot Formations vous accompagne
                à chaque étape du lancement pour transformer
                votre potentiel en résultats.
              </p>
            </div>

            <div className="self-stretch my-[2%] rounded-2xl w-1.25 bg-[#C7F8FF]"></div>
            <div className="self-stretch my-[3%] rounded-2xl w-0.75 bg-[#C7F8FF]"></div>
          </div>

          <div className="lg:order-2 order-1 flex-1">
            <Image src="/assets/small-logo.svg" alt="Small Logo" title="Spot Formation" width={112} height={67} className='flex items-center justify-center mx-auto mb-8 lg:hidden'/>
            <h2 className="lg:text-left text-[#1B365E] text-center text-[40px] md:text-[60px] leading-10 md:leading-19 font-light font-red-hat mb-8 md:mb-7">
              Spot Formations
            </h2>

            <div className="flex items-start justify-between gap-3">
              <p className="md:max-w-169 flex-1 text-[14px] sm:text-[16px] text-[#1D1D1D] leading-5 sm:leading-6.5 tracking-[0.2px] lg:mb-11.75">
                Découvrez nos{" "}
                <span className="font-bold">
                  solutions de formation et d’accompagnement sur mesure,
                </span>{" "} Spot Formations assure une
                assistance personnalisée qui s’aligne sur les parcours uniques
                des entreprises. La qualité de notre méthode est garantie par
                notre{" "}
                <span className="font-bold">
                  processus d’amélioration continue
                </span>
                .
              </p>
              <Image src="/assets/small-logo.svg" alt="Small Logo" title="Spot Formation" width={112} height={67} className="hidden lg:block absolute top-0 left-1/2 -translate-x-1/2 lg:hidden xl:block xl:static xl:translate-x-0 xl:translate-y-0 transition-transform"/>
            </div>


            <div className="lg:flex hidden gap-8 relative z-2">
              <Button variant="outline-gradient" onClick={() => window.open("/quiz", "_blank")} className="h-14.5 px-10">
                Se laisser guider
              </Button>
              <Button variant="gradient" onClick={() => {router.push('/formations')}} className="h-14.5 px-10">
                Choisir votre formation
              </Button>
            </div>
          </div>
          <div className="order-3 lg:hidden flex md:flex-row flex-col gap-8 md:w-fit w-full relative z-2">
            <Button variant="gradient" onClick={() => {router.push('/formations')}} className="h-14.5 md:w-fit w-full px-10">
              Choisir votre formation
            </Button>
            <Button variant="outline-gradient" onClick={() => window.open("/quiz", "_blank")} className="h-14.5 md:w-fit w-full px-10">
              Se laisser guider
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About